import html from './videoModule.html';
import {partial} from "../../../../utils/partial";
import {VideoPlayer} from "../../../../modules/videoPlayer";
import Mustache from 'mustache';

export class VideoModule {
  public element: HTMLElement;
  private videoPlayer: VideoPlayer;

  constructor(parentElement, data) {
    this.element = partial(Mustache.render(html, data));
    parentElement.appendChild(this.element);

    const controlsEl = this.element.querySelector('.videoControls') as HTMLElement;

    const videoEl = this.element.querySelector('video');
    this.videoPlayer = new VideoPlayer(videoEl, controlsEl);
    this.videoPlayer.showUI();
  }

  public kill() {
    this.videoPlayer.kill();
  }
}